import * as e from "react";
import { forwardRef as r } from "react";
const c = r(function(t, l) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 18 18",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("g", { clipPath: "url(#prefix__clip0_8218_971)" }, /* @__PURE__ */ e.createElement("rect", { fill: "#00599E", height: 18, rx: 9, width: 18 }), /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M11.7396 4.73957V4H5.89584V4.73957H3.66666V5.91667C3.66666 6.82293 4.09375 8.26043 6.19793 8.5104C6.67709 9.42709 7.67707 10.2292 8.78123 10.25H8.84373C9.95832 10.2292 10.9479 9.42709 11.4271 8.5104C13.5417 8.26043 13.9687 6.82293 13.9687 5.91667V4.73957H11.7396ZM9.8021 12.625V10.9792C9.8021 10.9792 9.23961 10.7083 8.83338 10.6875H8.7917C8.38546 10.7083 7.82293 10.9792 7.82293 10.9792V12.625C7.82293 13.7292 6.14585 13.8125 6.14585 13.8125V14.6667H11.4792V13.8125C11.4792 13.8125 9.8021 13.7292 9.8021 12.625ZM4.44793 6.28125V5.46875H5.89586V7.34373C5.89586 7.45831 5.90625 7.56249 5.91668 7.67707C5.09375 7.32291 4.44793 7.06251 4.44793 6.28125ZM13.1771 6.28125C13.1771 7.06251 12.5417 7.32291 11.7187 7.67707C11.7292 7.56249 11.7396 7.45831 11.7396 7.34373V5.46875H13.1771V6.28125Z",
        fill: "#fff",
        fillRule: "evenodd"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "prefix__clip0_8218_971" }, /* @__PURE__ */ e.createElement("rect", { fill: "#fff", height: 18, width: 18 })))
  );
});
export {
  c as MarketStatusPlaced
};
